module.exports = __webpack_public_path__ + "img/Shuaxing.9faf74bc.svg";